import Keycloak from 'keycloak-js'
import Axios from './axios'
import config from './config'

const keycloak = new Keycloak(config.keycloakConfig);

export const updateToken = async () => {
  try {
    await keycloak.updateToken(100);
    const token = getAccessToken();
    if (!token) throw new Error("Invalid");
    Axios.setAuthorization(getAccessToken()!);
    return token;
  } catch (error) {
    console.log(`not refreshed :: ` + new Date());
    await forceLogin();
  }
};

keycloak.onTokenExpired = updateToken;

export const initialize = () => {
  // Survey is rendered within iframes in many cases. Prevents redirect to keycloak in those cases.
  const isSurveyRoute = window.location.pathname.startsWith('/customer/survey/form/');

  return keycloak.init({
    onLoad: isSurveyRoute ? 'check-sso' : 'login-required',
  })
}

export const redirectToLogin = () => {
  keycloak.clearToken()
  keycloak.login()
}

export const logout = () => {
  return keycloak.logout()
}

export const forceLogin = () =>
  Promise.allSettled([logout, redirectToLogin].map((fn) => fn()))

export const getAccessToken = () => {
  return keycloak.token
}

export default keycloak